import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useGlobalContext } from '../../../Contexts/GlobalContext';
import { useState } from 'react';
import { RiAddCircleLine, RiApps2Line, RiArrowDownSLine, RiCheckboxCircleLine, RiCheckboxMultipleBlankLine, RiCloseCircleLine, RiDraftLine, RiForbid2Line, RiPlayCircleLine, RiSearchLine } from 'react-icons/ri';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAllSurveyAllocations } from '../qualSurveysActions';
import { Chip, styled, Tooltip, tooltipClasses } from '@mui/material';
import ParticipantCard from './ParticipantCard';
import PersonInfo from '../../../components/PersonInfo';
import { getStatusChipColor } from '../qualitativeUtils';
import NoData from '../../../components/NoData';
import LastFetched from '../../../components/LastFetched';
import { CustomTablePagination } from '../../../Utlils';
import SurveyTableLoader from '../../survey/surveyDetails/components/SurveyTableLoader';


const tabsData = [
    {
        label: "All",
        value: "",
        icon: <RiApps2Line size={22} />,
        secValue: 0,
    },
    {
        label: "Draft",
        value: 'draft',
        icon: <RiDraftLine size={22} />,
        secValue: 1,
    },
    {
        label: 'Invited',
        value: 'invited',
        icon: <RiAddCircleLine size={22} />,
        secValue: 3,
    },
    {
        label: 'Started',
        value: 'started',
        icon: <RiPlayCircleLine size={22} />,
        secValue: 4,
    },
    {
        label: 'Completed',
        value: 'completed',
        icon: <RiCheckboxCircleLine size={22} />,
        secValue: 5,
    },
    {
        label: 'Dropped',
        value: 'dropped',
        icon: <RiCloseCircleLine size={22} />,
        secValue: 6,
    },
    {
        label: 'Disqualified',
        value: 'disqualified',
        icon: <RiForbid2Line size={22} />,
        secValue: 7,
    },
];

const ParticipantManagementTable = () => {
    const tabName = "status"
    const navigate = useNavigate();
    const { id } = useParams();
    const { handleCopyEmail } = useGlobalContext();
    const urlParams = new URLSearchParams(window.location.search);
    const tabFromURL = urlParams.get(tabName);
    const [tab, setTab] = useState(tabFromURL || "");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [reset, setReset] = useState(false);
    const [filters, setFilters] = useState({
        search: '',
    });
    const [debouncedSurveySearchText, setDebouncedSurveySearchText] = useState(
        filters?.search || '',
    );
    const project = id;
    const selectedTab = tabsData?.find((d) => d.value === tab);
    const activeTab = selectedTab?.secValue || 0;
    const {
        data: allSurveyAllocations,
        isLoading: allSurveyAllocationsLoading,
        isError: allSurveyAllocationsError,
        refetch,
    } = useQuery({
        queryKey: [
            'all-survey-allocations',
            project,
            selectedTab?.secValue,
            page + 1,
            rowsPerPage,
            reset,
            debouncedSurveySearchText,
        ],
        queryFn: () =>
            getAllSurveyAllocations(
                {
                    project,
                    status: selectedTab?.secValue,
                    page: page + 1,
                    rows: rowsPerPage,
                    reset,
                    search: debouncedSurveySearchText,
                }
            ),
        staleTime: 10000,
        cacheTime: 15000,
    });


    const tableHeaders = ["Allocation ID", "Participant", "Status"]?.filter((item) => activeTab !== 0 ? item !== "Status" : item)
    const handleTabChange = (value) => {
        if (value === tab) return;
        setTab(value);
        if (!value) {
            navigate(``);
            return;
        }
        navigate(`?${tabName}=${value}`);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    useEffect(() => {
        const handler = setTimeout(() => {
            if (page != 0) {
                setPage(0);
            }
            setDebouncedSurveySearchText(filters?.search);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [filters?.search]);
    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip describeChild {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));

    // console.log({ allSurveyAllocations, allSurveyAllocationsLoading, allSurveyAllocationsError });
    return (
        <div>
            <div className="border-b border-gray-200">
                <div className="flex items-center overflow-x-auto">
                    {tabsData?.map((item, ind) => (
                        <button
                            key={ind}
                            type="button"
                            onClick={() => handleTabChange(item?.value)}
                            className={[
                                "flex-shrink-0 flex items-center gap-2 py-3 px-4 text-sm transition-all duration-150 border-b-2",
                                tab === String(item.value)
                                    ? "text-primary border-primary font-semibold"
                                    : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300 font-medium",
                            ].join(" ")}
                        >
                            {item.icon}
                            {item.label}
                        </button>
                    ))}
                </div>
            </div>
            <div className='space-y-3 py-3 '>
                <div className='flex items-center justify-between'>
                    <span></span>
                    {/* <input
                            type="search"
                            placeholder="Search participants"
                            className="w-[300px] h-10 border border-gray-300 rounded-md px-4"
                            value={filters?.search}
                            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
                        /> */}
                    <LastFetched
                        date={allSurveyAllocations?.lastFetched}
                        loading={allSurveyAllocationsLoading}
                        setReset={setReset}
                    />
                </div>
                <div className="w-full bg-white border border-[#E0E0E0] rounded-md overflow-hidden">
                    <div className="w-full flex flex-col">
                        {allSurveyAllocationsLoading ? (
                            <SurveyTableLoader />
                        ) : allSurveyAllocationsError ? (
                            <div className=" h-[200px] flex items-center justify-center">
                                <h1 className="text-[#666666]">Something went wrong </h1>
                            </div>
                        ) : <div>
                            <div className="w-full overflow-x-auto containerScroll">
                                <table
                                    className="whitespace-nowrap text-left w-full"
                                    id="table-to-xls-DATA"
                                >
                                    <thead className="h-[50px] bg-gray-50 border-b border-[#E0E0E0]">
                                        <tr>
                                            {tableHeaders?.map((item, ind) => (
                                                <th key={ind} className="text-[#666] text-[13px] font-[500] px-4 text-start ">{item}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allSurveyAllocations?.data?.length === 0 ? <td colSpan={9}>
                                            <div className="py-10">
                                                <NoData />
                                            </div>
                                        </td> : allSurveyAllocations?.data?.map((item, index) => (
                                            <tr key={index}
                                                className="border-b border-[#E0E0E0] transition-colors cursor-pointer hover:bg-blue-50/30"
                                            >
                                                <td className="px-4 py-3 text-sm font-medium">AID#{item?.allocationID}</td>
                                                <td className="px-4 py-3">
                                                    <HtmlTooltip
                                                        placement='bottom-start'
                                                        // className="w-[300px] test"
                                                        title={
                                                            <ParticipantCard
                                                                city={item.datasetDetails?.city}
                                                                country={item.datasetDetails?.country}
                                                                datasetID={item.datasetDetails.datasetID}
                                                                email={item.datasetDetails?.email}
                                                                firstName={item.datasetDetails.firstName}
                                                                lastName={item.datasetDetails?.lastName}
                                                                gender={item.datasetDetails?.gender}
                                                                phone={item.datasetDetails?.phone}
                                                                state={item.datasetDetails?.state}
                                                                _id={item?.datasetDetails?._id || ''}
                                                            />

                                                        }

                                                    >
                                                        <div className="space-y-1">
                                                            <div>
                                                                <h2 className="text-sm font-medium max-w-[175px] truncate">
                                                                    {`${item.datasetDetails?.firstName}${item.datasetDetails?.lastName ? ` ${item.datasetDetails?.lastName}` : ''}`}
                                                                </h2>

                                                            </div>
                                                            <div className="flex gap-1 items-center text-gray-500">
                                                                <p className="max-w-[130px] text-xs truncate font-normal">
                                                                    {
                                                                        item?.datasetDetails?.email
                                                                            ? item?.datasetDetails?.email
                                                                            : `${item.datasetDetails?.phone?.countryCode}${item?.datasetDetails?.phone?.number}`
                                                                    }
                                                                </p>
                                                                <RiCheckboxMultipleBlankLine
                                                                    size={12}
                                                                    className="cursor-pointer shrink-0"
                                                                    onClick={handleCopyEmail}
                                                                />
                                                            </div>
                                                        </div>
                                                    </HtmlTooltip>



                                                </td>

                                                {activeTab === 0 ? (
                                                    <td className="px-4 py-3">
                                                        <Chip
                                                            size='small'
                                                            color={getStatusChipColor(item?.status?.value)}
                                                            dot
                                                            label={item?.status?.label}
                                                        >
                                                            {item?.status?.label}
                                                        </Chip>
                                                    </td>
                                                ) : (
                                                    <></>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                        {allSurveyAllocations?.pagination?.totalPages > 1 &&
                            <CustomTablePagination
                                rowsPerPageOptions={[5, 15, 25, 50, 75, 100]}
                                sx={{ fontSize: '10px' }}
                                count={allSurveyAllocations?.pagination?.totalDocuments || 0}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                componentsProps={{
                                    select: {
                                        'aria-label': 'rows per page',
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                    },
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        }

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ParticipantManagementTable